import TermsOfService from './user/terms-of-service'

export default function () {
	return <TermsOfService />
}
